import { useEffect, useState } from 'react';
import '../views/app/dashboard/style.css';

const NumberCounter = ({ targetNumber }) => {
  const [currentNumber, setCurrentNumber] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      if (currentNumber < targetNumber) {
        setCurrentNumber(currentNumber + 1);
      } else {
        clearInterval(timer);
      }
    }, 150);

    return () => clearInterval(timer);
  }, [currentNumber, targetNumber]);

  return currentNumber;
};

export default NumberCounter;